<template>
  <el-form-item
    :class="{'is-look': disabled}"
    :label="item.label"
    :prop="item.key"
    :rules="item.rules">
    <el-input
      v-if="['input','text','password','email','textarea','number'].includes(item.type)"
      v-bind="$attrs"
      :type="item.subtype || item.type"
      v-on="$listeners"
      resize="none"
      :autosize="disabled ? true : (item.autoSize || { minRows: 4, maxRows: 6})"
      :placeholder="!isDisabled?item.placeholder:''"
      :disabled="isDisabled"
      @focus="handleFocusEvent(item.key)">
    </el-input>
    <el-input-number
      v-else-if="item.type==='inputNumber'"
      v-bind="$attrs"
      v-on="$listeners"
      @focus="handleFocusEvent(item.key)"
      :controls="!isDisabled && item.controls"
      :min="item.min"
      :max="item.max"
      :disabled="isDisabled"
      :precision="item.precision"
      :placeholder="!isDisabled?item.placeholder:''"
    >
    </el-input-number>
    <el-upload
      v-else-if="item.type==='upload'"
      class="upload-demo"
      :action="item.uploadUrl"
      :disabled="isDisabled"
      :on-success="handleSuccessUpload"
      :headers="uploadHeaders"
      multiple>
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <el-radio-group
      v-else-if="item.type==='radio'"
      v-bind="$attrs"
      v-on="$listeners"
      :placeholder="!isDisabled?item.placeholder:''"
      :disabled="isDisabled"
    >
      <component
        v-for="o in item.options||asyncOptions"
        :is="item.button?'el-radio-button':'el-radio'"
        :key="o.value"
        :label="o.value"
        :disabled="o.disabled"
        :border="item.border"
      >{{ o.label }}
      </component>
    </el-radio-group>
    <el-checkbox-group
      v-else-if="item.type==='checkbox'"
      v-bind="$attrs"
      v-on="$listeners">
      <component
        v-for="o in item.options||asyncOptions"
        :is="item.button?'el-checkbox-button':'el-checkbox'"
        :key="o.value"
        :disabled="o.disabled"
        :label="o.value"
        :border="item.border"
      >{{ o.label }}
      </component>
    </el-checkbox-group>

    <el-select
      v-else-if="item.type==='select'"
      v-bind="$attrs"
      v-on="$listeners"
      :size="item.size"
      :multiple="item.multiple"
      :readonly="item.readonly"
      :collapse-tags="item.tags"
      :clearable="item.clearable?false:item.clearable"
      :placeholder="!isDisabled?item.placeholder:''"
      :multiple-limit="item.limit"
      :disabled="isDisabled"
      @focus="handleFocusEvent(item.key)"
    >
      <el-option
        v-for="o in mapSelectOptions(item.props, item.options||asyncOptions)"
        :key="o.value"
        :label="o.label"
        :value="o.value"
        :disabled="o.disabled"
      >
      </el-option>
    </el-select>

    <tree-select
      v-else-if="item.type === 'treeSelect'"
      ref="treeSelect"
      v-bind="$attrs"
      v-on="$listeners"
      :placeholder="!isDisabled?item.placeholder:''"
      :disabled="isDisabled"
      :multiple="item.multiple"
      :options="item.options || asyncOptions"
      :filterable="item.filterable"
      :clearable="item.clearable"
      :props="item.props"
      :lazy="item.lazy"
      @focus="handleFocusEvent(item.key)"
      @loadNode="item.load($event, item.key)"
    />

    <el-switch
      v-else-if="item.type==='switch'"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="isDisabled"
    ></el-switch>
    <el-time-picker
      v-else-if="item.type==='time'"
      :is-range="item.subtype==='timerange' ? true : false"
      :format="item.valueFormat"
      v-bind="$attrs"
      range-separator="至"
      :start-placeholder="item.startPlaceholder"
      :end-placeholder="item.endPlaceholder"
      :readonly="item.readonly"
      :clearable="item.clearable?false:item.clearable"
      :placeholder="!isDisabled?item.placeholder:''"
      :disabled="isDisabled"
      v-on="$listeners"
      @focus="handleFocusEvent(item.key)"
    ></el-time-picker>

    <el-date-picker
      v-else-if="item.type==='date'"
      :type="item.subtype"
      :format="item.viewFormat||item.valueFormat"
      v-bind="$attrs"
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      v-on="$listeners"
      :disabled="isDisabled"
      :picker-options="getInitDatePickerTime(item.pickerTime)"
      @focus="handleFocusEvent(item.key)"
    ></el-date-picker>

    <form-upload
      v-else-if="item.type === 'file'"
      v-bind="$attrs"
      v-on="$listeners"
      :disabled="isDisabled">
    </form-upload>

    <dynamic-data-box
      v-else-if="item.type === 'databox'"
      v-bind="$attrs"
      v-on="$listeners"
      :valueFileld="item.valueFileld"
      :labelFileld="item.labelFileld"
      :hostUrl="item.url"
      :tableColumn="item.tableColumn"
      :entityPath="item.entityPath"
      :extendParms="item.extendParms"
      :extendSearch="item.extendSearch"
      :multiple="item.multiple"
      :disabled="isDisabled"
      @focus="handleFocusEvent(item.key)"
      @confirm="val => { getContent(val) }"
    >
    </dynamic-data-box>
    <el-calendar
      v-else-if="item.type === 'calendar'"
      v-bind="$attrs"
      v-on="$listeners">
    </el-calendar>
    <span v-else>未知控件类型</span>
  </el-form-item>
</template>
<script>
  import {initData} from '@/api/data'
  import TreeSelect from '@/components/TreeSelect/index.vue'
  import FormUpload from '@/components/FormUpload'
  import { getToken } from "@/utils/auth";

  export default {
    components: {TreeSelect, FormUpload},
    props: {
      item: {
        type: Object,
        required: true,
      },
      disabled: Boolean
    },
    data() {
      return {
        asyncOptions: [],
        uploadHeaders: {}
      }
    },
    computed: {
      isRange() {
        return this.subtype === "timerange";
      },
      isDisabled() {
        return this.item.disabled || this.disabled
      }
    },
    watch: {
      'item.params': {
        handler(val, oldVal) {
          if (val === undefined && oldVal === undefined) {
            return
          }
          if (!this.isObjectEqual(val, oldVal)) {
            if (this.item.hasOwnProperty('cascade')) {
              this.getAsyncCascadeOptions(val)
            }
          }
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      if (!this.item.hasOwnProperty('cascade')) this.getAsyncOptions()
      this.uploadHeaders = { Authorization: `Bearer ${getToken()}` }
    },
    methods: {
      getInitDatePickerTime(obj) {
        return Object.assign(obj || {}, {'firstDayOfWeek': 1})
      },
      getContent(val) {
        if (this.item.key === "projectId") {
          this.$emit('getProjectId', val.code)
        } else if (this.item.key === 'projectNode') {
          this.$emit('getProjectNode', val.id)
        } else {
          this.$emit('getContent', { key: this.item.key, value: val })
        }
      },
      handleSuccessUpload(response) {
        this.$emit('getFileId',response.data)
      },
      /**
       * 根据url获取option
       */
      getAsyncOptions() {
        const {optionsUrl, dicType, params, autoSelectFirst, props} = this.item
        let data = params
        if (dicType) {
          data = Object.assign({code: dicType}, data)
        }
        if (optionsUrl) {
          initData(optionsUrl, data).then(res => {
            if (res.code === 200) {
              this.asyncOptions = res.data.content || res.data;
              if (autoSelectFirst && this.asyncOptions && this.asyncOptions.length) {
                this.$nextTick(() => {
                  const obj = this.asyncOptions[0];
                  if (props) {
                    this.$emit('input', obj[props.value])
                  } else {
                    this.$emit('input', obj.value)
                  }
                })
              }
            }
          }).catch(err => {
            this.$message.error(err.message);
          });
        }
      },

      getAsyncCascadeOptions(params) {
        const {optionsUrl} = this.item
        if (optionsUrl) {
          initData(optionsUrl, params).then(res => {
            if (res.code === 200) {
              this.asyncOptions = res.data.content || res.data;
            }
          }).catch(err => {
            this.$message.error(err.message);
          });
        }
      },

      mapSelectOptions(props, options = []) {
        if (props) {
          const {label, value} = props
          return options.map(item => {
            item.label = item[label]
            item.value = item[value]
            return item
          })
        }
        return options
      },

      /**
       * 获取焦点事件
       * @param key 绑定对象的key
       */
      handleFocusEvent(key) {
        this.$emit('handleFocusEvent', key);
      },
      isObjectEqual(obj1, obj2) {
        const o1 = obj1 instanceof Object;
        const o2 = obj2 instanceof Object;
        if (!o1 || !o2) {    // 如果不是对象 直接判断数据是否相等
          return obj1 === obj2
        }
        // 判断对象的可枚举属性组成的数组长度
        if (Object.keys(obj1).length !== Object.keys(obj2).length) {
          return false;
        }
        for (const attr in obj1) {
          const a1 = Object.prototype.toString.call(obj1[attr]) === '[object Object]'
          const a2 = Object.prototype.toString.call(obj2[attr]) === '[object Object]'
          const arr1 = Object.prototype.toString.call(obj1[attr]) === '[object Array]'
          if (a1 && a2) {
            // 如果是对象继续判断
            return this.isObjectEqual(obj1[attr], obj2[attr])
          } else if (arr1) {
            // 如果是对象 判断
            if (obj1[attr].toString() !== obj2[attr].toString()) {
              return false;
            }
          } else if (obj1[attr] !== obj2[attr]) {
            // 不是对象的就判断数值是否相等
            return false
          }
        }
        return true
      }
    }
  }
</script>

<style scoped lang="scss">
  /*详情时去掉边框线*/
  .is-look {
    /deep/ .el-input__inner {
      color: #333;
      background: none;
      border: none;
      cursor: text !important;
    }

    /deep/ .el-textarea {
      .el-textarea__inner {
        color: #333;
        background: none;
        border: none;
        cursor: text !important;
      }
    }

    /deep/ .el-select__tags {
      .el-tag--info {
        color: #333;
        background: none;
        border: none;
        cursor: text !important;
        font-size: 13px;
      }
    }

    /deep/ .el-input__suffix {
      display: none;
    }
  }
</style>
